export const CARDS_PER_PLAYER = 5;
